import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locales/en/common.json";
import es from "../locales/es/common.json";

i18n.use(initReactI18next).init({
    lng: "es",
    resources: {
        en: {
            translation: en,
        },
        es: {
            translation: es,
        },
    },
    supportedLngs: ["en", "es"],
    fallbackLng: ["en", "es"],
});

export default i18n;
